import axios from "axios";
export default axios.create({
    baseURL: `${process.env.REACT_APP_CQC_API_PROTOCOL}${process.env.REACT_APP_CQC_API_URL}`
});